import { MessageCircle } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";

const InvestmentOpportunitySection = ({ scrollToContact, onOpenWhatsApp }) => {
  const { t } = useLanguage();

  return (
    <section className="py-20 md:py-28 bg-[#B5613B] relative overflow-hidden" data-testid="opportunity-section">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl translate-x-1/2 -translate-y-1/2" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#D4A03D] rounded-full blur-3xl -translate-x-1/2 translate-y-1/2" />
      </div>
      <div className="max-w-7xl mx-auto px-4 md:px-8 relative z-10">
        <span className="text-xs uppercase tracking-[0.3em] text-white/70 font-accent mb-4 block text-center">{t.opportunity.label}</span>
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-white text-center mb-8" data-testid="opportunity-title">{t.opportunity.title}</h2>
        <div className="max-w-3xl mx-auto text-center mb-16">
          <p className="text-white/90 leading-relaxed mb-4">{t.opportunity.p1}</p>
          <p className="text-white/90 leading-relaxed mb-4">{t.opportunity.p2}</p>
          <p className="text-white/90 leading-relaxed">{t.opportunity.p3}</p>
        </div>
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {t.opportunity.stats.map((stat, index) => (
            <div key={index} className="bg-white/10 backdrop-blur-sm p-8 text-center border border-white/20" data-testid={`stat-${index}`}>
              <span className={`font-heading text-5xl md:text-6xl block mb-2 ${index === 2 ? "text-[#D4A03D]" : "text-white"}`}>{stat.value}</span>
              <span className="text-sm uppercase tracking-widest text-white/70">{stat.label}</span>
            </div>
          ))}
        </div>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button onClick={onOpenWhatsApp} data-testid="opportunity-whatsapp-cta" className="inline-flex items-center justify-center gap-3 bg-white text-[#B5613B] hover:bg-[#FAF8F5] px-8 py-4 uppercase tracking-widest text-sm font-medium transition-all duration-300 hover:scale-105 shadow-lg">
            <MessageCircle className="w-5 h-5" />
            {t.opportunity.ctaWhatsApp}
          </button>
          <button onClick={scrollToContact} data-testid="opportunity-call-cta" className="inline-flex items-center justify-center gap-3 bg-transparent border-2 border-white text-white hover:bg-white hover:text-[#B5613B] px-8 py-4 uppercase tracking-widest text-sm font-medium transition-all duration-300">
            {t.opportunity.ctaCall}
          </button>
        </div>
      </div>
    </section>
  );
};

export default InvestmentOpportunitySection;
